import * as Yup from 'yup';

export const closeCashRegisterSchema = Yup.object().shape({
  comment: Yup.string().required(),
  cash: Yup.number().required(),
  creditCard: Yup.number().required(),
  transference: Yup.number().required(),
});
